import { useState } from 'react';
import { css } from '@emotion/react';
import Navigation from '@/components/ui/Navigation';
import PricingPlans from '@/components/ui/PricingPlans';

const pageStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background-color: #f8f8f5;
`;

const mainStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  margin-top: 160px;
  width: 100%;
`;

const contentStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 80px;
  width: 100%;
  padding-bottom: 40px;
`;

const GAP_CYCLE = [24, 16, 12];

export default function PricingPage() {
  const [compact, setCompact] = useState(false);
  const [altStyle, setAltStyle] = useState(true);
  const [gapIndex, setGapIndex] = useState(1);
  const [darkListText, setDarkListText] = useState(false);

  return (
    <div css={pageStyles}>
      <Navigation
        onLogoClick={() => setCompact(prev => !prev)}
        onTryFreeClick={() => setAltStyle(prev => !prev)}
        onLoginClick={() => setGapIndex(prev => (prev + 1) % GAP_CYCLE.length)}
        onPricingClick={() => setDarkListText(prev => !prev)}
      />
      <div css={mainStyles}>
        <div css={contentStyles}>
          <PricingPlans
            compact={compact}
            altStyle={altStyle}
            cardGap={GAP_CYCLE[gapIndex]}
            darkListText={darkListText}
          />
        </div>
      </div>
    </div>
  );
}
